var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.27,46.48H144.73a98.27,98.27,0,0,0-98.25,98.25V355.27a98.27,98.27,0,0,0,98.25,98.25H355.27a98.27,98.27,0,0,0,98.25-98.25V144.73A98.27,98.27,0,0,0,355.27,46.48Zm63.16,301.77a70.2,70.2,0,0,1-70.18,70.18H151.75a70.2,70.2,0,0,1-70.18-70.18V151.75a70.2,70.2,0,0,1,70.18-70.18h196.5a70.2,70.2,0,0,1,70.18,70.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.2,144.73A105.27,105.27,0,1,0,355.47,250,105.31,105.31,0,0,0,250.2,144.73Zm0,175.45A70.18,70.18,0,1,1,320.38,250,70.29,70.29,0,0,1,250.2,320.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 362.49,
    cy: 137.71,
    r: 21.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramlogo);
export default __webpack_public_path__ + "static/media/instagram logo.4d42c0341da87bc5ecacc475bcbbb118.svg";
export { ForwardRef as ReactComponent };